// SAB-522: /cookies — previously 404'd. Renders the Cookie Policy page with the
// canonical Termly-hosted policy embedded/linked, plus the consent-management
// control (resetConsent) that the consent banner points at (SAB-430/431).
// No Aeropay section here (Aeropay Section 6 requires ToS-in-Terms and
// Privacy-in-Privacy only).
import { useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { Button } from '@/components/ui/button';
import { resetConsent } from '@/lib/consent';
import CustomizeModal from '@/components/CookieConsent/CustomizeModal';
import LegalPageShell, { TERMLY_POLICIES } from './LegalPageShell';

export default function CookiesPage() {
  const [prefsOpen, setPrefsOpen] = useState(false);

  // SAB-706: on web, reopen the consent banner (unchanged behaviour). On native
  // the banner is suppressed (cookie consent is a web mechanism; Apple governs on
  // native), so open the per-category toggles directly instead of a dead re-prompt.
  const handleManage = () => {
    if (Capacitor.isNativePlatform()) setPrefsOpen(true);
    else resetConsent();
  };

  return (
    <LegalPageShell title="Cookie Policy" termlyUrl={TERMLY_POLICIES.cookies}>
      <section className="space-y-3 rounded-md border border-border bg-card px-4 py-4">
        <h2 className="text-lg font-semibold text-foreground">Manage your cookie preferences</h2>
        <p className="text-sm text-muted-foreground">
          Reopen the consent choices to review or change which non-essential
          cookies (analytics, marketing) you allow.
        </p>
        <Button type="button" variant="outline" size="sm" onClick={handleManage}>
          Manage cookie preferences
        </Button>
      </section>
      <CustomizeModal open={prefsOpen} onClose={() => setPrefsOpen(false)} />
    </LegalPageShell>
  );
}
